<template>
    <div
        style="display: flex;flex-direction: column;margin-top: 20px;flex: 1;margin-right: 20px;margin-left: 20px;">
        <div v-if="section3Loading" class="flex justify-center">
            <span class="loading loading-dots loading-md"></span>
        </div>
        <div v-else>
            <!-- 标签源切换器 -->
            <div class="mb-4">
                <div class="flex items-center gap-3">
                    <span class="text-sm font-medium">{{ $tt('标签源：') }}</span>
                    <div class="dropdown">
                        <label tabindex="0" class="btn btn-sm btn-outline">
                            {{ loadingResources ? $tt('加载中...') : getResourceLabel(currentResource) }}
                            <svg class="w-4 h-4 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
                            </svg>
                        </label>
                        <ul tabindex="0" class="dropdown-content menu p-2 shadow bg-base-100 rounded-box w-52 z-[9999]">
                            <li v-for="(label, resource) in resourceOptions" :key="resource">
                                <a @click="handleResourceChange(resource)" :class="{'active': currentResource === resource}">
                                    {{ $tt(label) }}
                                </a>
                            </li>
                        </ul>
                    </div>
                    <button class="btn btn-sm btn-primary" @click="handleSearchWithNewResource" :disabled="section3Loading">
                        <span v-if="section3Loading" class="loading loading-spinner loading-xs"></span>
                        <span v-else>{{ $tt('搜索') }}</span>
                    </button>
                </div>
            </div>
            <div v-if="songList.length === 0">
                <span style="margin-left: 30%;margin-top: 30%;">{{ $tt('暂无歌曲信息') }}</span>
            </div>
            <div v-else>
                <div class="overflow-x-auto">
                    <table class="table">
                        <!-- head -->
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>
                                    <div class="flex items-center">
                                        <div class="ml-4">{{ $tt('封面') }}</div>
                                        <div class="ml-9">
                                            <div>{{ $tt('标题') }}</div>
                                            <div>{{ $tt('艺术家') }}</div>
                                        </div>
                                    </div>
                                </th>
                                <th>{{ $tt('专辑') }}</th>
                                <th>{{ $tt('操作') }}</th>
                                <th>
                                    <div>{{ $tt('音轨号') }}</div>
                                    <div>{{ $tt('CD号') }}</div>
                                </th>
                                <th>{{ $tt('年份') }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item,index) in songList" :key="index">
                                <th class="w-4">
                                    <button class="btn btn-xs" @click="copyAll(item)">
                                        <svg-icon name="left-arrow" class="icon w-4 h-4" />
                                    </button>
                                </th>
                                <td class="max-w-1/3">
                                    <div class="flex items-center gap-3">
                                        <div class="avatar">
                                            <div class="mask mask-squircle w-16 h-16 cursor-pointer" @click="handleCopy('album_img',item.album_img)">
                                                <img :src="item.album_img" alt="" v-if="item.album_img" />
                                                <div v-else></div>
                                            </div>
                                        </div>
                                        <div>
                                            <div class="font-bold">
                                                <div @click="handleCopy('title',item.name)" :class="getClass(item.title_score)">
                                                    {{
                                                        item.name
                                                    }}
                                                </div>
                                            </div>
                                            <div class="text-sm opacity-50">
                                                <div @click="handleCopy('artist',item.artist)" :class="getClass(item.artist_score)">
                                                    {{ item.artist }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </td>
                                <td class="max-w-1/4">
                                    <span class="font-bold">
                                        <div @click="handleCopy('album',item.album)" :class="getClass(item.album_score)">
                                            {{item.album }}
                                        </div>
                                    </span>
                                </td>
                                <td>
                                    <div class="flex items-center gap-2">
                                        <div @click="handleCopy('lyric',item)" class="music-item">
                                            <button class="btn btn-outline btn-xs whitespace-nowrap" :disabled="!item.is_lyric || loadingLyricId === item.id">
                                                <span v-if="loadingLyricId === item.id" class="loading loading-spinner loading-xs"></span>
                                                <span v-else>{{ $tt('歌词') }}</span>
                                            </button>
                                        </div>
                                        <button v-if="item.is_download" class="btn btn-xs btn-outline whitespace-nowrap" :disabled="loadingDownloadId === item.id" @click="handleDownload(item)">
                                            <span v-if="loadingDownloadId === item.id" class="loading loading-spinner loading-xs"></span>
                                            <span v-else>{{ $tt('音乐下载') }}</span>
                                        </button>
                                    </div>
                                </td>
                                <th>
                                    <div v-if="item.tracknumber" class="flex">
                                        <div @click="handleCopy('tracknumber',item.tracknumber)" class="music-item">
                                            {{item.tracknumber}}
                                        </div>
                                        <div>/</div>
                                        <div @click="handleCopy('totaltracks',item.totaltracks)" class="music-item">
                                            {{item.totaltracks}}
                                        </div>
                                    </div>
                                    <div v-if="item.discnumber" class="flex">
                                        <div @click="handleCopy('discnumber',item.discnumber)" class="music-item">
                                            {{item.discnumber}}
                                        </div>
                                        <div>/</div>
                                        <div @click="handleCopy('totaldiscs',item.totaldiscs)" class="music-item">
                                            {{item.totaldiscs}}
                                        </div>
                                    </div>
                                </th>
                                <th>
                                    <div @click="handleCopy('year',item.year)" class="music-item">
                                        {{ item.year }}
                                    </div>
                                </th>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import SvgIcon from '@/components/SvgIcon.vue';
    export default {
        name: 'resource',
        components: { SvgIcon },
        props: {
            songList: {type: Array, required: true},
            section3Loading: {type: Boolean, required: true}
        },
        data() {
            return {
                loadingLyricId: null,
                loadingDownloadId: null,
                currentResource: localStorage.getItem('resource') || 'netease',
                resourceOptions: {},
                loadingResources: false
            }
        },
        mounted() {
            // 监听localStorage的变化，保持与其他组件的同步
            this.syncResourceWithStorage()
            // 加载标签源列表
            this.loadResourceOptions()
        },
        methods: {
            syncResourceWithStorage() {
                const storedResource = localStorage.getItem('resource')
                if (storedResource && this.resourceOptions[storedResource]) {
                    this.currentResource = storedResource
                }
            },
            getDefaultResourceOptions() {
                return {
                    'netease': '网易云音乐',
                    'spotify': 'Spotify',
                    'musicbrainz': 'MusicBrainz',
                    'migu': '咪咕音乐',
                    'kuwo': '酷我音乐',
                    'kugou': '酷狗音乐',
                    'smart_tag': '智能标签'
                }
            },
            async loadResourceOptions() {
                this.loadingResources = true
                try {
                    // 首先设置默认的内置标签源
                    const defaultOptions = this.getDefaultResourceOptions()
                    this.resourceOptions = {...defaultOptions}

                    // 尝试从API获取插件标签源
                    const res = await this.$api.scriptMgmt.getTagSources({'page_size': 99, 'status': 'active'})
                    console.log(res)
                    if (res.result && res.data && res.data.items) {
                        // 将API返回的插件标签源合并到resourceOptions中
                        res.data.items.forEach(plugin => {
                            if (plugin.unique_id && plugin.display_name) {
                                this.resourceOptions[plugin.unique_id] = plugin.display_name
                            }
                        })
                    }
                } catch (error) {
                    console.warn('获取标签源插件失败，使用默认标签源:', error)
                    // 如果API调用失败，使用默认标签源
                    this.resourceOptions = this.getDefaultResourceOptions()
                } finally {
                    this.loadingResources = false
                }
            },
            getClass(v) {
                if (v === 1) {
                    return 'text-yellow-600 music-item'
                } else if (v === 2) {
                    return 'text-neutral-600 music-item'
                } else if (v === 0) {
                    return 'text-rose-400 music-item'
                } else {
                    return 'music-item'
                }
            },
            handleCopy(k, v) {
                if (k === 'lyric') {
                    this.loadingLyricId = v.id
                    this.$parent.handleCopy(k, v, () => {
                        this.loadingLyricId = null
                    })
                } else {
                    this.$parent.handleCopy(k, v)
                }
            },
            copyAll(item) {
                this.$parent.copyAll(item)
            },
            toggleLock() {
                this.$parent.toggleLock()
            },
            handleDownload(item) {
                this.loadingDownloadId = item.id
                this.$api.Task.downloadResource({
                    'song_name': item.name,
                    'song_id': item.id,
                    'resource': item.resource || localStorage.getItem('resource') || 'netease'
                }).then((res) => {
                    if (res.result) {
                        this.$myMsg.notify({
                            title: this.$tt('下载任务已创建'),
                            content: this.$tt('音乐正在后台下载中'),
                            type: 'success',
                            time: 2000,
                        })
                    } else {
                        this.$myMsg.notify({
                            title: this.$tt('下载失败'),
                            content: res.message || this.$tt('创建下载任务失败'),
                            type: 'error',
                            time: 2000,
                        })
                    }
                }).finally(() => {
                    this.loadingDownloadId = null
                })
            },
            getResourceLabel(resource) {
                const label = this.resourceOptions[resource] || resource
                return this.$tt(label)
            },
            handleResourceChange(resource) {
                this.currentResource = resource
                localStorage.setItem('resource', resource)
                // 切换后自动搜索
                this.handleSearchWithNewResource()
            },
            handleSearchWithNewResource() {
                // 调用父组件的toggleLock方法进行搜索
                this.toggleLock()
            }
        }
    }
</script>

<style scoped>
/* 确保下拉框在最高层级 */
.dropdown {
    position: relative;
}

.dropdown-content {
    z-index: 9999 !important;
    position: absolute;
}

/* 确保下拉菜单在最上层 */
.dropdown:focus-within .dropdown-content,
.dropdown:active .dropdown-content,
.dropdown:hover .dropdown-content {
    z-index: 9999 !important;
}

</style>
